import { IncidentManagements } from "../../types/Entities/IncidentManagement";
import moment from "moment";
import Timer from "./Timer";
import React, { useState, useEffect } from "react";
import { TextArea, TextAreaField } from "@sainsburys-tech/luna-form";

import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal";
import { GridWrapper, GridItem } from "@sainsburys-tech/luna-grid";
import { CancelButton, TextButton, FilledButton } from "@sainsburys-tech/luna-button";
import ConfirmationModal from "../Common/ConfirmationModal";
import FormAlerts from "../Common/FormAlerts";
import IncidentManagementApi from "../../api/IncidentManagementApi";
import ApiClient from "../../api/ApiClient";
import { useApiClient } from "../../context/AppContext";

import CSS from "csstype";

const IncideDetailsTable = (props: {
  table: IncidentManagements;
  onData: any;
}) => {
  const apiClient = useApiClient();
  const errorStyle: CSS.Properties = {
    textAlign: "left",
    fontSize: "medium",
    marginTop: "15px",
    marginBottom: "10px",
  };

  console.log(props);
  // const [ updateRequired , setUpdateRequired ] = useState("")
  const [updatedTableData, setUpdatedTableData] = useState(props.table);
  const updateRequired = `${updatedTableData.updateFrequency} ${
    updatedTableData.updateFrequency > 1 ? "hours" : "hour"
  }`;
  const [isOpen, setIsOpen] = useState(false);
  const [isopenfrequency, setIsOpenFrequency] = useState(false); //for modal
  const [disabledButton, setDisabledButton] = useState(false);
  const [disablesavebutton, setDisableSaveButton] = useState(false);
  const [frequency, setFrequency] = useState<string | number>("Please Select"); //state value variable
  const [modalState, setModalState] = useState<"save" | "discard" | false>(
    false
  );
  const [errorAlert, setErrorAlert] = useState<false | string>(false);
  const [successAlert, setSuccessAlert] = useState<false | string>(false);
  const [warningMessage, setwarningMessage] = useState("");

  console.log(props.table);
  const handleClose = () => {
    setIsOpenFrequency(false);
    setwarningMessage("");
  };

  const handleFrequencyChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
    workOrderNumber: string
  ) => {
    setwarningMessage("");
    const newFrequency = event.target.value; // Get the selected value
    setFrequency(newFrequency); // Update state

    console.log("Frequency is:", newFrequency);
    console.log("workordernumber", workOrderNumber);
  };
  const clearAlerts = () => {
    setErrorAlert(false);
    setSuccessAlert(false);
  };
  const scrollToTop = () =>
    document.querySelector("div.ln-o-container.content")?.scrollTo(0, 0);

  const handleSave = () => {
    // debugger;
    clearAlerts();
    if (frequency === "Please Select") {
      setwarningMessage("Please select a value from dropdown"); // Show warning popup
      return; // Stop execution
    }
    // const newFrequency = frequency || props.table.updateFrequency;
    IncidentManagementApi.addUpdateFrequency(
      apiClient,
      props.table.workOrderNumber,
      Number(frequency)
    )
      .then((response) => {
        setwarningMessage("");
        debugger;
        if (response != null) {
          debugger;

          setUpdatedTableData((prevData) => {
            const newData = structuredClone(prevData); // Deep copy
            newData.updateFrequency = Number(frequency);
            setFrequency(newData.updateFrequency);
            setIsOpenFrequency(false);

            return newData;
          });
          scrollToTop();
          props.onData("success alert");
        } else {
          props.onData("error alert");
        }
      })
      .catch((error) => {
        console.log("Error updating frequency:", error);//error 
        props.onData("error alert");
      });
  };


  const handleDiscardForm = () => {
    setModalState(false);
  };

  return (
    <>
      <ConfirmationModal
        showModal={modalState}
        onClose={handleDiscardForm}
        onSave={handleSave}
        onDiscard={handleDiscardForm}
        onComplete={handleDiscardForm}
      />

      <FormAlerts
        showError={errorAlert}
        showSuccess={successAlert}
        onClose={clearAlerts}
      />

      {
        <Modal
          small={true}
          alert
          hideCloseButton
          open={isOpen}
          headingId="dialog-modal"
          style={{
            display: "flow",
            alignContent: "center",
            textAlign: "-webkit-center",
          }}
        >
          <div>
            <GridItem size="1" className="ln-u-hard">
              <div>
                <b>Name: {props.table.name ? props.table.name : " "}</b>
                <br />

                <b>Phone: {props.table.phone ? props.table.phone : " "}</b>
                <br />
                <b>Email: {props.table.email ? props.table.email : " "}</b>
                <br />
              </div>
            </GridItem>
            <FilledButton
              style={{ float: "right" }}
              onClick={() => setIsOpen(false)}
            >
              Close
            </FilledButton>
          </div>
        </Modal>
      }
      <table className="workorderdetails">
        <tbody style={{ border: "1 px black" }}>
          <tr>
            <th>Work Order</th>
            <td>{props.table.workOrderNumber}</td>
            <th>Date Created</th>
            <td>
              {props.table.dateCreated
                ? moment(props.table.dateCreated).format("DD MMM YY, HH:mm")
                : ""}
              {}
            </td>
          </tr>
          <tr>
            <th>Site</th>
            <td>
              {props.table.siteName} {props.table.siteDesc}
            </td>
            <th>Date Last Modified</th>
            <td>
              {props.table.dateModified
                ? moment(props.table.dateModified).format("DD MMM YY, HH:mm")
                : ""}
            </td>
          </tr>
          <tr>
            <th>Site Type</th>
            <td>{props.table.siteType} </td>
            <th>Date Completed</th>
            <td>{props.table.dateServiceCompleted
                ? moment(props.table.dateServiceCompleted).format("DD MMM YY, HH:mm")
                : ""}</td>
          </tr>
          <tr>
            <th 
            // className="linkbutton" 
            // onClick={() => setIsOpen(true)}
            >
              Region
            </th>
            <td 
            // className="linkbutton" 
            // onClick={() => setIsOpen(true)}
            >
              {props.table.region}
               {/* | <span> {props.table.name}</span> */}
            </td>
            <th>Incident Timer</th>
            {/* <td>{Timer(props.table.timer)}</td> */}
            <td>{props.table.incidentTimer}</td>
          </tr>
          <tr>
            <th>Location at Site</th>
            <td>{props.table.location}</td>
            <th>Updates Required</th>
            <td>
                          {updateRequired}
              <a
                              href="#"
                              style={{ marginLeft: "2%" }}
                onClick={(e) => {
                  e.preventDefault();
                  setIsOpenFrequency(true);
                  setFrequency("Please Select");
                }}
              >
                              Click here to update
              </a>

              {
                <Modal
                  small={true}
                  alert
                  hideCloseButton
                  open={isopenfrequency}
                  headingId="dialog-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <div style={{ width: "100%", padding: "20px" }}>
                    {/* Header */}
                    <div
                      style={{
                        padding: "0.5rem 1rem",
                        border: "1px solid #d8d8d8",
                        backgroundColor: "#d8d8d8",
                        textAlign: "left",
                        fontWeight: "bold",
                      }}
                    >
                      Choose value from the drop down to update timer frequency :
                    </div>

                    {/* Dropdown & Save Button in One Row */}
                    <div
                      className="change_frequency"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: "15px",
                        gap: "10px",
                      }}
                    >
                      {/* Select Dropdown (Takes Half Width) */}
                      <select
                        id="frequency"
                        value={frequency}
                        onChange={(event) =>
                          handleFrequencyChange(
                            event,
                            props.table.workOrderNumber
                          )
                        }
                        style={{
                          width: "50%",
                          padding: "15px",
                          border: "1px solid #ccc",
                          backgroundColor: "white",
                          cursor: "pointer",
                          fontSize: "16px",
                        }}
                      >
                        <option defaultValue="Please Select">
                          Please Select
                        </option>
                        <option value="1">1hr</option>
                        <option value="2">2hrs</option>
                        <option value="3">3hrs</option>
                      </select>

                      {/* Save Button (Takes Half Width) */}
                      <FilledButton
                        id="submit-button"
                        className="feedback-submitButton"
                        onClick={handleSave}
                        disabled={disablesavebutton}
                        style={{
                          width: "50%",
                          padding: "15px",
                          backgroundColor: "#FO6C00",
                          color: "white",
                          border: "none",
                          fontWeight: "bold",
                          cursor: "pointer",
                          fontSize: "16px",
                        }}
                      >
                        Save
                      </FilledButton>
                    </div>

                    {/* Close Button */}
                    <div style={{ marginTop: "15px" }}>
                      <FilledButton
                        fullWidth
                        id="close-button"
                        className="feedback-closeButton"
                        onClick={handleClose}
                        disabled={disabledButton}
                        style={{
                          width: "100%",
                          padding: "15px",
                          backgroundColor: "#FO6C00",
                          border: "none",
                          color: "white",
                          fontWeight: "bold",
                          cursor: "pointer",
                          fontSize: "16px",
                        }}
                      >
                        Close
                      </FilledButton>
                    </div>
                    {warningMessage && (
                      <div>
                        <p
                          className="ln-c-field-info ln-c-field-info--error"
                          style={errorStyle}
                        >
                          {warningMessage}
                        </p>{" "}
                      </div>
                    )}
                  </div>
                </Modal>
              }
            </td>
          </tr>
          <tr>
            <th>Incident Category</th>
            <td>{props.table.subCategory}</td>
            <th>Incident Status</th>
            <td>{props.table.status}</td>
          </tr>
          <tr>
            <th>Incident type</th>
            <td>{props.table.problemType}</td>
            <th>Client Name</th>
            <td>{props.table.clientName}</td>
          </tr>
          <tr>
            <th rowSpan={2} colSpan={1}>
              Incident Description
            </th>
            <td colSpan={3}>
              <TextArea
                rows={5}
                name="textarea-1"
                value={props.table.problemDescription}
                disabled
                style={{
                  opacity: "1",
                  background: "#f0f0f0",
                  border: "none",
                  paddingLeft: "0px",
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default IncideDetailsTable;



